/**
 * Official-ish store mark SVGs for the download CTAs. Monochrome so they
 * inherit button text colour (white on volt, foreground on outline). Lucide
 * doesn't ship brand marks for trademark reasons, so we inline them here.
 */

interface LogoProps {
  className?: string;
  size?: number;
}

export function AppleLogo({ className, size = 20 }: LogoProps) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M17.564 12.645c-.028-3.09 2.524-4.572 2.64-4.644-1.437-2.1-3.677-2.388-4.478-2.42-1.907-.194-3.725 1.123-4.694 1.123-.97 0-2.466-1.095-4.055-1.065-2.087.03-4.011 1.214-5.086 3.083-2.17 3.763-.555 9.332 1.558 12.393 1.033 1.497 2.266 3.182 3.884 3.122 1.557-.062 2.146-1.009 4.027-1.009 1.88 0 2.41 1.009 4.06.978 1.676-.03 2.738-1.528 3.764-3.031 1.186-1.74 1.675-3.424 1.705-3.51-.038-.017-3.296-1.265-3.325-5.02zM14.515 3.626c.86-1.042 1.44-2.49 1.282-3.93-1.238.05-2.737.824-3.627 1.866-.796.924-1.493 2.4-1.305 3.812 1.38.107 2.79-.702 3.65-1.748z" />
    </svg>
  );
}

export function GooglePlayLogo({ className, size = 20 }: LogoProps) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
    >
      <path d="M3.609 1.814 13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a.996.996 0 0 1 .609-.92zm10.89 10.893 2.302 2.302-10.937 6.27 8.635-8.572zm3.71-5.729 2.473 1.415a1.5 1.5 0 0 1 0 2.614l-2.473 1.415-2.498-2.498 2.498-2.946zM5.864 2.658l10.938 6.27-2.302 2.302L5.864 2.658z" />
    </svg>
  );
}
